$(window).on('load', function() {
  // Skip the script if it's on the homepage
  if ($('body').hasClass('template-index')) {
    return;
  }

  // The slider being synced must be initialized first
  $('#carousel').flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    itemWidth: 135,
    itemMargin: 8,
    asNavFor: '#slider'
  });

  $('#slider').flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    before: function(data) {
      var index = parseInt(data.currentSlide + 1);
      $(".product-single__photos li:nth-child(" + index + ")").find("video").trigger('pause');
    },
    after: function(data) {
      var index = parseInt(data.currentSlide + 1);
      $(".product-single__photos li:nth-child(" + index + ")").find("video").trigger('play');
    },
    sync: "#carousel"
  });

  setTimeout(function() {
    $("#slider").find(".icon__loading_spinner").addClass("custom_hidden");
    $("#slider").find(".product-single__photos").addClass("loaded");
  }, 500);


  

  if ($(window).width() > 768) {
    var numbers_array = [];
    $(".thisisrow3 a.grid-product__image-link").each(function() {
      var getheight = $(this).height();
      console.log("getheight==" + getheight + "<br>");
      numbers_array.push(getheight);
    });
    var biggest = Math.min.apply(null, numbers_array);
    var biggest = biggest + "px";
    $(".thisisrow3 a.grid-product__image-link img").css("max-height", biggest);

    // row1
    var numbers_array1 = [];
    $(".thisisrow1 a.grid-product__image-link").each(function() {
      var getheight1 = $(this).height();
      numbers_array1.push(getheight1);
    });
    var biggest1 = Math.min.apply(null, numbers_array1);
    var biggest1 = biggest1 + "px";
    $(".thisisrow1 a.grid-product__image-link img").css("max-height", biggest1);

    // row2
    var numbers_array2 = [];
    $(".thisisrow2 a.grid-product__image-link").each(function() {
      var getheight2 = $(this).height();
      numbers_array2.push(getheight2);
    });
    var biggest2 = Math.min.apply(null, numbers_array2);
    var biggest2 = biggest2 + "px";
    $(".thisisrow2 a.grid-product__image-link img").css("max-height", biggest2);

    // row4
    var numbers_array4 = [];
    $(".thisisrow4 a.grid-product__image-link").each(function() {
      var getheight4 = $(this).height();
      numbers_array4.push(getheight4);
    });
    var biggest4 = Math.min.apply(null, numbers_array4);
    var biggest4 = biggest4 + "px";
    $(".thisisrow4 a.grid-product__image-link img").css("max-height", biggest4);
  }

  if (($(window).width() > 590) && ($(window).width() < 769)) {
    // row1
    var numbers_array1 = [];
    $(".tabrow1 a.grid-product__image-link").each(function() {
      var getheight1 = $(this).height();
      numbers_array1.push(getheight1);
    });
    var biggest1 = Math.min.apply(null, numbers_array1);
    var biggest1 = biggest1 + "px";
    $(".tabrow1 a.grid-product__image-link img").css("max-height", biggest1);

    // row3
    var numbers_array3 = [];
    $(".tabrow3 a.grid-product__image-link").each(function() {
      var getheight3 = $(this).height();
      numbers_array3.push(getheight3);
    });
    var biggest3 = Math.min.apply(null, numbers_array3);
    var biggest3 = biggest3 + "px";
    $(".tabrow3 a.grid-product__image-link img").css("max-height", biggest3);

    // row2
    var numbers_array2 = [];
    $(".tabrow2 a.grid-product__image-link").each(function() {
      var getheight2 = $(this).height();
      numbers_array2.push(getheight2);
    });
    var biggest2 = Math.min.apply(null, numbers_array2);
    var biggest2 = biggest2 + "px";
    $(".tabrow2 a.grid-product__image-link img").css("max-height", biggest2);

    // row4
    var numbers_array4 = [];
    $(".tabrow4 a.grid-product__image-link").each(function() {
      var getheight4 = $(this).height();
      numbers_array4.push(getheight4);
    });
    var biggest4 = Math.min.apply(null, numbers_array4);
    var biggest4 = biggest4 + "px";
    $(".tabrow4 a.grid-product__image-link img").css("max-height", biggest4);

    // row5
    var numbers_array5 = [];
    $(".tabrow5 a.grid-product__image-link").each(function() {
      var getheight5 = $(this).height();
      numbers_array5.push(getheight5);
    });
    var biggest5 = Math.min.apply(null, numbers_array5);
    var biggest5 = biggest5 + "px";
    $(".tabrow5 a.grid-product__image-link img").css("max-height", biggest5);

    // row6
    var numbers_array6 = [];
    $(".tabrow6 a.grid-product__image-link").each(function() {
      var getheight6 = $(this).height();
      numbers_array6.push(getheight6);
    });
    var biggest6 = Math.min.apply(null, numbers_array6);
    var biggest6 = biggest6 + "px";
    $(".tabrow6 a.grid-product__image-link img").css("max-height", biggest6);
  }

  $(window).resize(function() {
    if ($(window).width() > 768) {
      var numbers_array = [];
      $(".thisisrow3 a.grid-product__image-link").each(function() {
        var getheight = $(this).height();
        console.log("getheight==" + getheight + "<br>");
        numbers_array.push(getheight);
      });
      var biggest = Math.min.apply(null, numbers_array);
      var biggest = biggest + "px";
      $(".thisisrow3 a.grid-product__image-link img").css("max-height", biggest);

      // row1
      var numbers_array1 = [];
      $(".thisisrow1 a.grid-product__image-link").each(function() {
        var getheight1 = $(this).height();
        numbers_array1.push(getheight1);
      });
      var biggest1 = Math.min.apply(null, numbers_array1);
      var biggest1 = biggest1 + "px";
      $(".thisisrow1 a.grid-product__image-link img").css("max-height", biggest1);

      // row2
      var numbers_array2 = [];
      $(".thisisrow2 a.grid-product__image-link").each(function() {
        var getheight2 = $(this).height();
        numbers_array2.push(getheight2);
      });
      var biggest2 = Math.min.apply(null, numbers_array2);
      var biggest2 = biggest2 + "px";
      $(".thisisrow2 a.grid-product__image-link img").css("max-height", biggest2);

      // row4
      var numbers_array4 = [];
      $(".thisisrow4 a.grid-product__image-link").each(function() {
        var getheight4 = $(this).height();
        numbers_array4.push(getheight4);
      });
      var biggest4 = Math.min.apply(null, numbers_array4);
      var biggest4 = biggest4 + "px";
      $(".thisisrow4 a.grid-product__image-link img").css("max-height", biggest4);
    }

    if (($(window).width() > 590) && ($(window).width() < 769)) {
      // row1
      var numbers_array1 = [];
      $(".tabrow1 a.grid-product__image-link").each(function() {
        var getheight1 = $(this).height();
        numbers_array1.push(getheight1);
      });
      var biggest1 = Math.min.apply(null, numbers_array1);
      var biggest1 = biggest1 + "px";
      $(".tabrow1 a.grid-product__image-link img").css("max-height", biggest1);

      // row3
      var numbers_array3 = [];
      $(".tabrow3 a.grid-product__image-link").each(function() {
        var getheight3 = $(this).height();
        numbers_array3.push(getheight3);
      });
      var biggest3 = Math.min.apply(null, numbers_array3);
      var biggest3 = biggest3 + "px";
      $(".tabrow3 a.grid-product__image-link img").css("max-height", biggest3);

      // row2
      var numbers_array2 = [];
      $(".tabrow2 a.grid-product__image-link").each(function() {
        var getheight2 = $(this).height();
        numbers_array2.push(getheight2);
      });
      var biggest2 = Math.min.apply(null, numbers_array2);
      var biggest2 = biggest2 + "px";
      $(".tabrow2 a.grid-product__image-link img").css("max-height", biggest2);

      // row4
      var numbers_array4 = [];
      $(".tabrow4 a.grid-product__image-link").each(function() {
        var getheight4 = $(this).height();
        numbers_array4.push(getheight4);
      });
      var biggest4 = Math.min.apply(null, numbers_array4);
      var biggest4 = biggest4 + "px";
      $(".tabrow4 a.grid-product__image-link img").css("max-height", biggest4);

      // row5
      var numbers_array5 = [];
      $(".tabrow5 a.grid-product__image-link").each(function() {
        var getheight5 = $(this).height();
        numbers_array5.push(getheight5);
      });
      var biggest5 = Math.min.apply(null, numbers_array5);
      var biggest5 = biggest5 + "px";
      $(".tabrow5 a.grid-product__image-link img").css("max-height", biggest5);

      // row6
      var numbers_array6 = [];
      $(".tabrow6 a.grid-product__image-link").each(function() {
        var getheight6 = $(this).height();
        numbers_array6.push(getheight6);
      });
      var biggest6 = Math.min.apply(null, numbers_array6);
      var biggest6 = biggest6 + "px";
      $(".tabrow6 a.grid-product__image-link img").css("max-height", biggest6);
    }

    if ($(window).width() < 591) {
      $(".yuyuy .grid__item .grid-product__image").css("max-height", "auto");
    }
  });

  $(window).scroll(function() {
    if ($(window).width() < 480) {
      if ($(window).scrollTop() >= 10) {
        console.log("10");
        $('.header-wrapper').addClass('fixed-header');
      } else {
        $('.header-wrapper').removeClass('fixed-header');
      }
    } else {
      if ($(window).scrollTop() >= 70) {
        console.log("70");
        $('.header-wrapper').addClass('fixed-header');
      } else {
        $('.header-wrapper').removeClass('fixed-header');
      }
    }
  });

  $(document).ready(function() {
    $("#AddToCart").hover(function() {
      $('#add_cart_icon a').css("color", "#fff");
    }, function() {
      $('#add_cart_icon a').attr("style", "");
    });
  });

  $(window).load(function() {
    var isMobile = false;
    var isDesktop = false;
    if ($(window).width() > 768) {
      var count = $('.index .grid .grid-product').length;
      for (var i = 0; i < count; i += 3) {
        var num = [];
        $(".index .grid .grid-product a.grid-product__image-link").slice(i, i + 3).each(function() {
          var max = $(this).height();
          num.push(max);
        });

        var big = Math.min.apply(null, num);
        var big = big + "px";
        $(".index .grid .grid-product a.grid-product__image-link").slice(i, i + 3).find("img").css("max-height", big);
      }
      isDesktop = true;
    } else {
      isMobile = true;
    }

    updateRes();

    $(window).resize(function() {
      updateRes();
    });

    function updateRes() {
      if ($(window).width() < 768) {
        if (isMobile == true) {
          $(".grid-product__image.desktop-only").each(function() {
            var url = $(this).attr("src");
            url = url.replace("600x600", "1024x1024");
            $(this).attr("src", url);
          });
          isMobile = false;
          isDesktop = true;
        }

      } else {
        if (isDesktop == true) {
          $(".grid-product__image.desktop-only").each(function() {
            var url = $(this).attr("src");
            url = url.replace("1024x1024", "600x600");
            $(this).attr("src", url);
          });
          isDesktop = false;
          isMobile = true;
        }
      }
    }
  });
});

